import {
  CircularProgress,
  Stack,
  TableCell,
  TableContainer,
  TableContainerProps,
} from '@mui/material';
import { styled } from '@mui/system';

const tableMaxWidth = 450;

export const BackupTablesWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: '20px',
  alignItems: 'start',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column-reverse',
  },
}));

export const RightSideWrapper = styled(Stack)(({ theme }) => ({
  maxWidth: `${tableMaxWidth}px`,
  width: '100%',
  flexDirection: 'column',
  gap: '20px',
  alignItems: 'end',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column-reverse',
  },
}));

export const TableContainerStyled = styled(TableContainer)<TableContainerProps>(
  () => ({
    maxWidth: `${tableMaxWidth}px`,
  }),
);

export const TableCellAlighnRight = styled(TableCell)({
  textAlign: 'right',
});

export const BackupCircularProgress = styled(CircularProgress)({
  marginRight: '8px',
});
